import { adminDashboardConstants } from '../_constants';

export function adminDashboardCards(state = {}, action) {
  switch (action.type) {
    case adminDashboardConstants.GET_ADMIN_DASHBOARD_CARDS_REQUEST:
      return {
        loading: true
      };
    case adminDashboardConstants.GET_ADMIN_DASHBOARD_CARDS_SUCCESS:
      return {
        items: action.adminDashboardCards
      };
    case adminDashboardConstants.GET_ADMIN_DASHBOARD_CARDS_FAILURE:
      return { 
        error: action.error
      };
    default:
      return state
  }
}

export function adminDashboardCharts(state = {}, action) {
  switch (action.type) {
    case adminDashboardConstants.GET_ADMIN_DASHBOARD_CHARTS_REQUEST:
      return {
        loading: true
      };
    case adminDashboardConstants.GET_ADMIN_DASHBOARD_CHARTS_SUCCESS:
      return {
        items: action.adminDashboardCharts
      };
    case adminDashboardConstants.GET_ADMIN_DASHBOARD_CHARTS_FAILURE:
      return { 
        error: action.error
      };
    default:
      return state
  }
}